import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useUpdateAppointmentAsyncRequestStatusMutation } from "@/modules/patients/services/__generated__/useUpdateAppointmentAsyncRequestStatusMutation.graphql"

const mutation = graphql`
  mutation useUpdateAppointmentAsyncRequestStatusMutation($input: UpdateAppointmentAsyncRequestStatusInput!) {
    updateAppointmentAsyncRequestStatus(input: $input) {
      appointment {
        id
        asyncRequestStatus
      }
      errors {
        ... on ActionNotAllowedOnClosedOrCancelledAppointment {
          message
        }
        ... on AppointmentNotFound {
          appointmentId
          message
        }
        ... on CannotUpdateAppointmentAsyncRequestStatusForNonAsyncChannel {
          message
        }
      }
    }
  }
`
const useUpdateAppointmentQmsAsyncRequestStatusMutation = () => {
  const [commit, isFlight] = useMutation<useUpdateAppointmentAsyncRequestStatusMutation>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useUpdateAppointmentAsyncRequestStatusMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useUpdateAppointmentQmsAsyncRequestStatusMutation }
